/**
 * Timezone-related constants
 */

// Storage key for user timezone (used in multiple places)
export const TIMEZONE_STORAGE_KEY = 'user-timezone';
